import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { EntPesticides } from "../../../models/chemicalization/pesticides";
import { EntPesticidesFilter, EntReportPesticidesFilter } from "../../../models/filters/pesticidesFilter";
import { BlobResponse } from "../../../models/report";
import { Paths } from "../../../paths";

export const pesticidesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getPesticidesList: builder.query<ResponseDataGet<EntPesticides>, EntPesticidesFilter>({
	  query: (filter) => ({
		url: `${Paths.chemicalization.register_of_pesticides}/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getPesticidesById: builder.query<ResponseDataTest<EntPesticides>, number>({
	  query: (id) => ({
		url: `${Paths.chemicalization.register_of_pesticides}/${ id }`,
		method: 'GET'
	  })
	}),
	addPesticides: builder.mutation<ResponseDataTest<EntPesticides>, EntPesticides>({
	  query: (body) => ({
		url: `${Paths.chemicalization.register_of_pesticides}`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editPesticides: builder.mutation<ResponseDataTest<EntPesticides>, EntPesticides>({
	  query: (body,) => ({
		url: `${Paths.chemicalization.register_of_pesticides}`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deletePesticides: builder.mutation<ResponseDataTest<EntPesticides>, number>({
	  query: (id) => ({
		url: `${Paths.chemicalization.register_of_pesticides}/${ id }`,
		method: 'DELETE',
	  }),
	}),
	reportPesticides: builder.mutation<BlobResponse, EntReportPesticidesFilter>({
	  query: (payload) => {
		const { periodStart, periodEnd, language } = payload;

		return {
		  url: `/departments/chemicalization/report/pesticide-register`,
		  method: "POST",
		  params: {
			periodStart,
			periodEnd,
			language
		  },
		  body: JSON.stringify(payload),
		  responseHandler: (response) => response.blob(),
		};
	  },
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddPesticidesMutation,
  useDeletePesticidesMutation,
  useEditPesticidesMutation,
  useLazyGetPesticidesListQuery,
  useReportPesticidesMutation
} = pesticidesApi;
